import { FC } from 'react';
import Skeleton from 'react-loading-skeleton';
import withErrorBoundary from '../withErrorBoundary';

interface MoTableProps {
  rows: number;
  cols: number;
}

const MoTable: FC<MoTableProps> = ({ rows, cols }) => {
  return (
    <div className="mo-table-wr">
      <table className="mo-table">
        <thead>
          <tr>
            {[...Array(cols)].map((_, index) => (
              <th key={index}>
                <Skeleton width={100} />
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {[...Array(rows)].map((_, rowIndex) => (
            <tr key={rowIndex}>
              {[...Array(cols)].map((_, index) => (
                <td key={index}>
                  <Skeleton width={100} />
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default withErrorBoundary(MoTable, 'MoTable');
